import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, unref as _unref, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { onBeforeMount, watch } from "@vue/runtime-core";

import TheMenu from "./components/TheMenu.vue";

import { useAuthStore } from "@/store/auth";
import { RouterView, useRouter } from "vue-router";
import { useLangStore } from "./store/lang";


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const authStore = useAuthStore();
const router = useRouter();
const langStore = useLangStore();

onBeforeMount(() => {
  if (authStore.tryLogin()) router.push({ name: "calendar" });
  langStore.changeLang();
});

watch(
  () => authStore.didAutoLogout,
  async (curVal, oldVal) => {
    if (curVal && curVal !== oldVal) {
      router.replace({ name: "main" });
    }
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(TheMenu),
    _createVNode(_unref(RouterView), null, {
      default: _withCtx((slotProps) => [
        _createVNode(_Transition, {
          name: "route",
          mode: "out-in"
        }, {
          default: _withCtx(() => [
            (_openBlock(), _createBlock(_resolveDynamicComponent(slotProps.Component)))
          ]),
          _: 2
        }, 1024)
      ]),
      _: 1
    })
  ], 64))
}
}

})